import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../utils/parseError';

const deleteDayType = async ({ finalFormValidation, state, userId, updateState, removeResourceDayTypes, Toast, refreshPage }) => {
  if (!finalFormValidation()) {
    return null;
  }
  const resourceId = state.resource.id;
  const { itemDetails } = state;
  const date = moment(itemDetails.date).format('YYYY-MM-DD');
  const parameters = {
    resourceId,
    fromDate: date,
    toDate: date,
    userId
  };
  // store dayType parameters for optimistic re-ender
  itemDetails.dayTypeParams = parameters;
  await updateState({itemDetails});
  // now delete existing resource day type
  const { resource } = state;
  const day = moment(date, 'YYYY-MM-DD').format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Resource Day Type Deleted', description: `For ${resource.name} on ${day}`};
  const { fromDate, toDate } = parameters;
  try {
    await removeResourceDayTypes(resourceId, fromDate, toDate, userId);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeResourceDayTypes',
          message: parseError(error)
        }
      });
      console.log(error);
        notification = {
          type: 'error',
          message: "Deleting Resource Day Type Failed",
          description: `For [${resource.name} on ${day}]: ${parseError(error)}`
        };
      }
  }
  Toast(notification);
  refreshPage();
}

export default deleteDayType;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/dayType/deleteDayType.js